import { parse, parseISO } from 'date-fns';

export const MAX_CONTENT_LENGTH = 500;

export interface WorkerSearchRow {
  id: number;
  active: boolean;
  avatar_url: string | null;
  user: {
    id: number;
    first_name: string | null;
    last_name: string | null;
    email: string | null;
  } | null;
}

export interface DirectAnnouncementForm {
  title: string;
  message: string;
  expDate: string;
  expTime: string;
  workers: WorkerSearchRow[];
}

export interface DirectAnnouncementPayload {
  title: string;
  message: string;
  expireAt: string;
  userIds: number[];
}

// user.id is the User id the backend matches against workers.user_id.
// worker.id (the Worker record id) would target the wrong rows.
export function selectUserIds(workers: WorkerSearchRow[]): number[] {
  return workers
    .map((w) => w.user?.id)
    .filter((id): id is number => typeof id === 'number');
}

export function buildDirectAnnouncementPayload(
  form: DirectAnnouncementForm,
): DirectAnnouncementPayload {
  return {
    title: form.title.trim(),
    message: form.message.trim(),
    expireAt: parse(
      form.expTime,
      'HH:mm',
      parseISO(form.expDate),
    ).toISOString(),
    userIds: selectUserIds(form.workers),
  };
}

export function validateTestAnnouncement(
  form: DirectAnnouncementForm,
): string | null {
  if (!form.title.trim()) return 'Title is required.';
  if (!form.message.trim()) return 'Message is required.';
  if (form.message.length > MAX_CONTENT_LENGTH) {
    return `Message must be 1–${MAX_CONTENT_LENGTH} characters.`;
  }
  if (selectUserIds(form.workers).length < 1) {
    return 'Select at least one worker to send to.';
  }
  if (!form.expDate || !form.expTime) {
    return 'Expiry date and time are required.';
  }
  if (parse(form.expTime, 'HH:mm', parseISO(form.expDate)) <= new Date()) {
    return 'Expiry time should be in future.';
  }
  return null;
}
